// extracted by mini-css-extract-plugin
export default {"button":"button-with-badge_button__Hg7UB","badge":"button-with-badge_badge__72GzT"};